// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + {"535":"login","940":"request"}[chunkId] + "." + {"535":"c37bd66d","940":"806038ab"}[chunkId] + ".js";
};